// import React, { useState } from 'react';
// import { BarChart } from '@mui/x-charts/BarChart';
// import { ChartsTooltip } from '@mui/x-charts/ChartsTooltip';
// import Typography from '@mui/material/Typography';
// import Box from '@mui/material/Box';
// import Select from '@mui/material/Select';
// import MenuItem from '@mui/material/MenuItem';

// // SVG Icons
// const rightArrowIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//   <path d="M9 6L15 12L9 18" stroke="#98A2B3" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>`;

// const svgIcons = [
//   '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.66667 0.5H11.25M3.66667 4H11.25M3.66667 7.5H11.25M0.75 0.5H0.755833M0.75 4H0.755833M0.75 7.5H0.755833" stroke="#98A2B3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
//   '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.82715 8.91667L12.7438 6L9.82715 3.08333M3.99382 3.08333L1.07715 6L3.99382 8.91667M8.07715 0.75L5.74382 11.25" stroke="#98A2B3" strokeWidth="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
//   '<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.3033 7.29166V3.96666C10.3033 2.98656 10.3033 2.49652 10.1126 2.12217C9.94479 1.79289 9.67707 1.52517 9.34779 1.3574C8.97344 1.16666 8.4834 1.16666 7.5033 1.16666H3.76997C2.78988 1.16666 2.29983 1.16666 1.92549 1.3574C1.5962 1.52517 1.32849 1.79289 1.16071 2.12217C0.969971 2.49652 0.969971 2.98656 0.969971 3.96666V10.0333C0.969971 11.0134 0.969971 11.5035 1.16071 11.8778C1.32849 12.2071 1.5962 12.4748 1.92549 12.6426C2.29983 12.8333 2.78988 12.8333 3.76997 12.8333H5.63664M6.8033 6.41666H3.3033M4.46997 8.74999H3.3033M7.96997 4.08332H3.3033M7.09497 11.0833L8.26164 12.25L10.8866 9.62499" stroke="#98A2B3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
//   '<svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.19043 1.91062C1.19043 1.34411 1.19043 1.06085 1.30855 0.90471C1.41145 0.768683 1.56873 0.684508 1.739 0.674342C1.93443 0.662673 2.17012 0.819795 2.64148 1.13404L8.77556 5.22342C9.16504 5.48308 9.35978 5.61291 9.42765 5.77655C9.48698 5.91961 9.48698 6.0804 9.42765 6.22346C9.35978 6.3871 9.16504 6.51693 8.77556 6.77658L2.64148 10.866C2.17012 11.1802 1.93443 11.3373 1.739 11.3257C1.56873 11.3155 1.41145 11.2313 1.30855 11.0953C1.19043 10.9392 1.19043 10.6559 1.19043 10.0894V1.91062Z" stroke="#98A2B3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
// ];

// const iconTypes = ['MCQ', 'Coding Challenge', 'Assignment', 'Video'];


// export default function CompletionStatus() {
//   const [selectedModule, setSelectedModule] = useState('JavaScript');
//   const modules = ['HTML', 'CSS', 'JavaScript', 'NodeJS', 'React'];

//   const completedData = [90, 85, 80, 75, 70, 50, 45, 45, 45, 45, 45, 45, 25, 45, 45, 45, 25];
//   const pendingData = [10, 15, 20, 25, 30, 50, 55, 55, 55, 55, 55, 55, 75, 55, 55, 55, 75];


//   return (
//     <Box sx={{ 
//       width: '758px',
//       height: '229px',
//       padding: '20px',
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       overflow: 'hidden'
//     }}>
//       {/* Header */}
//       <Box sx={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         mb: 1,
//         height: '28px'
//       }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
//           <Typography sx={{ fontWeight: 500, fontSize: '16px !important' }}>
//             Completion Status
//           </Typography>
//           <Box sx={{ display: 'flex', gap: 3 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Box sx={{ width: 12, height: 12, bgcolor: '#5654D4', borderRadius: 1 }} />
//               <Typography sx={{ color: '#6B7280', fontSize: '12px !important' }}>Completed</Typography>
//             </Box>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Box sx={{ width: 12, height: 12, bgcolor: '#FD5457', borderRadius: 1 }} />
//               <Typography sx={{ color: '#6B7280', fontSize: '12px !important' }}>Pending</Typography>
//             </Box>
//           </Box>
//         </Box>
//         <Select
//           value={selectedModule}
//           onChange={(e) => setSelectedModule(e.target.value)}
//           variant="standard"
//           disableUnderline
//           sx={{
//             minWidth: 120,
//             fontSize: '16px',
//             color: '#667085',
//           }}
//         >
//           {modules.map((module) => (
//             <MenuItem key={module} value={module}>{module}</MenuItem>
//           ))}
//         </Select>
//       </Box>

//       {/* Chart Section */}
//       <Box sx={{ height: '157px', mt: 1 }}>
//         <Typography sx={{ 
//           color: '#344054 !important',
//           fontSize: '10px !important',
//           paddingBottom:'5px !important',
//           paddingLeft:'10px !important',
//            marginBottom:'10px !important',
//         }}>
//           Students
//         </Typography>

//         <Box sx={{ 
//           position: 'relative',
//           width: '726px',
//           height: '137px'
//         }}>
//           {/* Y-axis labels */}
//           <Box sx={{ 
//             position: 'absolute',
//             left: 0,
//             top: 0,
//             bottom: 25,
//             width: '35px',
//             zIndex: 2,
             
//             backgroundColor: 'white'
//           }}>
//             {[100, 80, 60, 40, 20, 0].map((value) => (
//               <Typography
//                 key={value}
//                 sx={{
//                   position: 'absolute',
//                   right: '8px',
//                   top: `${(100 - value) * 0.9}%`,
//                   transform: 'translateY(-50%)',
//                   fontSize: '10px !important',
//                   color: '#6B7280'
//                 }}
//               >
//                 {value}
//               </Typography>
//             ))}
//           </Box>

//           {/* Scrollable Chart Container */}
//           <Box
//             className="scroll-container"
//             sx={{
//               position: 'relative',
//               marginLeft: '35px',
//               overflowX: 'auto',
//               overflowY: 'hidden',
//               '&::-webkit-scrollbar': {
//                 height: '8px',
//               },
//               '&::-webkit-scrollbar-track': {
//                 backgroundColor: '#F1F1F1',
//                 borderRadius: '4px',
//               },
//               '&::-webkit-scrollbar-thumb': {
//                 backgroundColor: '#C1C1C1',
//                 borderRadius: '4px',
//               },
//             }}
//           >
//             <Box sx={{ 
//               position: 'relative',
//               width: '1000px',
//               height: '137px',

//             }}>
//               {/* Reference lines */}
//               {[100, 80, 60, 40, 20, 0].map((value) => (
//                 <Box
//                   key={value}
//                   sx={{
//                     position: 'absolute',
//                     left: 0,
//                     right: 0,
//                     top: `${(100 - value) * 0.9}%`,
//                     borderTop: '1px dashed #E5E7EB',
//                     zIndex: 0
//                   }}
//                 />
//               ))}

//               {/* Chart */}
//               <BarChart
//                 series={[
//                   {
//                     data: completedData,
//                     stack: 'A',
//                     color: '#5654D4',
//                     valueFormatter: () => '',
//                   },
//                   {
//                     data: pendingData,
//                     stack: 'A',
//                     color: '#FD5457',
//                     valueFormatter: () => '',
//                   },
//                 ]}
//                 xAxis={[{
//                   scaleType: 'band',
//                   data: Array.from({ length: 17 }, (_, i) => `${i}`),
//                   categoryGapRatio: 0.6,
//                   tickSize: 0,
//                    tickLabelStyle: { display: 'none' },
//                    axisLine: { stroke: 'none' }, 
//                    strokeWidth: 0 
//                 }]}
//                 yAxis={[{ 
//                   min: 0,
//                   max: 100,
//                   tickSize: 0,
//                   tickLabelStyle: { display: 'none' },
//                   axisLine: { stroke: 'none' }, 
//                   strokeWidth: 0 
//                 }]}
//                 grid={false}
//                 height={137}
//                 borderRadius={5}    
//                 width={1000}
//                 margin={{ 
//                   left: 0,
//                   right: 35,
//                   top: 10,
//                   bottom: 25
//                 }}
//                 // tooltip={{trigger:'item'}}
//                 // slots={{
//                 //     tooltip:CustomTooltipContent
//                 // }}
//               />


//               {/* Bottom Icons */}
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   bottom: 0,
//                   left: 0,
//                   right: 35,
//                   display: 'grid',
//                   gridTemplateColumns: `repeat(17, 1fr)`,
//                   gap: '0px',
//                   justifyItems: 'center',
//                   alignItems: 'center',
//                   height: '24px',
//                   backgroundColor: 'white'
//                 }}
//               >
//                 {Array.from({ length: 17 }, (_, i) => (
//                   <Box 
//                     key={i} 
//                     dangerouslySetInnerHTML={{ __html: svgIcons[i % 4] }}
//                     sx={{
//                       width: 16,
//                       height: 16,
//                       display: 'flex',
//                       justifyContent: 'center',
//                       alignItems: 'center',
//                     }}
//                   />
//                 ))}
//               </Box>
//             </Box>
//           </Box>

//           {/* Items Label */}
//           <Typography sx={{ 
//             position: 'absolute',
//             right: 0,
//             bottom: 0,
//             color: '#6B7280',
//             fontSize: '10px !important'
//           }}>
//             Items
//           </Typography>
//         </Box>
//       </Box>
//     </Box>
//   );
// } 


import { Fragment, useContext } from 'react';
import Select from '@mui/material/Select';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import constants from '../../../../constants';
import { BarChart } from '@mui/x-charts/BarChart';
import TestSvgIcon from '../../../../Svg/TestSvgIcon';
import CircularProgress from '@mui/material/CircularProgress';
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate';
import AlertContext from '../../../../../src/context/AlertContext';
import useCommonFunctionHooks from '../../../../Hooks/useCommonFunctionHooks';
import { colors } from '@mui/material';
import { convertFieldResponseIntoMuiTextFieldProps } from '@mui/x-date-pickers/internals';

export default function CompletionStatus() {
  const [selectedModule, setSelectedModule] = useState(null);
  const [modules, setModules] = useState([]);
const { id } = useParams();
const axios = useAxiosPrivate();
const Alert = useContext(AlertContext);
const {getCatchBlockDetails} = useCommonFunctionHooks();
const [completionStatus,setCompletionStatus] = useState({ scoreRatioRes: [] });
const [isStatusLoading, setIsStatusLoading] = useState(false);
/* for module trigger */
//   useEffect(() => {
//   if (!selectedModule?.mid) return;

//   const fetchCompletionStatus = async () => {
//     setIsStatusLoading(true);
//     try {
//       const res = await axios.get(`node/admin/batch/db/c_status`, {
//         params: { batchid: id, mid: selectedModule.mid },
//         headers: { "Content-type": "application/json" },
//       });

//       if (res.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR) {
//         Alert.setShowNotify({
//           show: true,
//           title: "Info",
//           msg: res.data.msg,
//         });
//         return;
//       }

//       setCompletionStatus(res.data.data);
//     } catch (err) {
//       getCatchBlockDetails(err);
//     } finally {
//       setIsStatusLoading(false);
//     }
//   };

//   fetchCompletionStatus();
// }, [selectedModule?.mid]);

// Replace both useEffects with this single one:

useEffect(() => {
  const fetchData = async () => {
    setIsStatusLoading(true);
    try {
      const moduleId = selectedModule?.mid || null;
      
      const res = await axios.get(`node/admin/batch/db/c_status`, {
        params: { batchid: id, mid: moduleId },
        headers: { "Content-type": "application/json" },
      });

      if (res.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR) {
        Alert.setShowNotify({
          show: true,
          title: "Info",
          msg: res.data.msg,
        });
        return;
      }

      setCompletionStatus(res.data.data);
      
      if (!selectedModule) {
        const fetchedModules = res.data.data.modules || [];
        setModules(fetchedModules);
        
        if (fetchedModules.length > 0) {
          setSelectedModule(fetchedModules[0]);
        }
      }
    } catch (error) {
      getCatchBlockDetails(error);
    } finally {
      setIsStatusLoading(false);
    }
  };

  fetchData();
}, [id, selectedModule?.mid]);


   const completedData = completionStatus?.scoreRatioRes?.map(item => 
    (item.completed_count / item.total_count) * 100
  ) || [];
  
  const pendingData = completionStatus?.scoreRatioRes?.map(item => 
    (item.pending_count / item.total_count) * 100
  ) || [];

  
 
  const barWidth = 25; // Width for one bar
const visibleBars = 20; // Bars visible before scroll
const totalBars = completionStatus?.scoreRatioRes?.length || 0;

const chartWidth = Math.max(barWidth * visibleBars, barWidth * totalBars);


  const moduleChange = (e) => {
    setSelectedModule(e.target.value)
  }


    const chartData = completionStatus?.scoreRatioRes?.map((item, index) => ({
   x: `${item.assignmentname || `Assignment`}-${index + 1}`,
  completed: (item.completed_count / item.total_count) * 100,
  pending: item.completed_count > 0 
    ? ((item.pending_count / item.total_count) * 100) - 1 
    : (item.pending_count / item.total_count) * 100,
  gap: item.completed_count > 0 ? 1 : 0, 
  completed_count: item.completed_count,
  pending_count: item.pending_count,
  libType: item.libtype,
})) || [];

  return (
    <div className="completion-container">
      {isStatusLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '229px' }}>
          <CircularProgress />
        </div>
      ):(
        <>
      <div className="header-container">
        <div className="header-left">
          <div className="completion-title">
            Completion Status
          </div>
          <div className="legend-wrapper">
            <div className="legend-item">
              <div className="legend-box legend-box-completed" />
              <div className="legend-text">Completed</div>
            </div>
            <div className="legend-item">
              <div className="legend-box legend-box-pending" />
              <div className="legend-text">Pending</div>
            </div>
          </div>
         </div>

        <Select
          value={selectedModule}
          onChange={moduleChange}
          variant="standard"
          disableUnderline
          className="custome-select-module"
          renderValue={(selected) => selected?.mname || 'Select Module'}
        >
          {modules.map((module) => (
            <MenuItem key={module.mid} value={module} className="custome-menu-item" >{module.mname}</MenuItem>
          ))}
        </Select>
      </div>

      <div className="chart-section">
        <div className="students-label">
          Students
        </div>

        <div className="chart-container">
          <div className="y-axis-labels">
            {[100, 80, 60, 40, 20, 0].map((value) => (
              <div
                key={value}
                className="y-axis-label"
                style={{
                  top: `${(100 - value) * 0.9}%`
                }}
              >
                {value}
              </div>
            ))}
          </div>

          <div className="scroll-container">
            <div className="chart-inner" style={{ width: `${chartWidth}px` }}>
              {[100, 80, 60, 40, 20, 0].map((value) => (
                <div
                  key={value}
                  className="reference-line"
                  style={{
                     top: value === 100 ? '12%' :
                          value === 80 ? '27%' :
                          value === 60 ? '41%' :
                          value === 40 ? '55%' :
                          value === 20 ? '70%' :
                          '88%'  // for 0
                        }}
                />
              ))}
              <BarChart
  dataset={chartData}
  series={[
    {
      dataKey: 'completed',
      stack: 'total',
      color: '#5654D4',
    },
    {
      dataKey: 'gap',
      stack: 'total',
      color: 'transparent',
    },
    {
      dataKey: 'pending',
      stack: 'total',
      color: '#FD5457',
    },
  ]}
  xAxis={[{
    scaleType: 'band',
    dataKey: 'x',
    categoryGapRatio: 0.5,
    barGapRatio: 0.35,
    tickSize: 0,
    tickLabelStyle: { display: 'none' },
    axisLine: { stroke: 'none',display:'none' },
    strokeWidth: 0,
    display:'none',
    visible:false
  }]}
  yAxis={[{
    min: 0,
    max: 100,
    tickSize: 0,
    tickLabelStyle: { display: 'none' },
    axisLine: { stroke: 'none !important',display:'none' },
    strokeWidth: 0,
    display:'none',
    visible:false
  }]}
  slotProps={{
    tooltip: {
      style: {
        backgroundColor: '#fff',
        border: '1px solid #ddd',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      },
    },
  }}
  tooltip={{ 
    trigger: 'item',
    axisContent: {
      sx: {
        fontWeight: 'bold',
      }
    },
    itemContent: ({ itemData }) => {
      const dataIndex = itemData.dataIndex;
      const item = chartData[dataIndex];

      return (
  <div className="barchart-tooltip-container">
    <div className='tooltip-head'>
      <span className='tooltip-header'>{item?.x}</span>
    </div>
    <div className='tooltip-body'>
      <div className='content'>
        <div className="content-wrapper">
          <span className="status-dot completed"></span>
          <span className='content-head'>Completed :</span>
          <span className='content-data'>{item?.completed_count} students</span>
        </div>
      </div>
      <div className='content'>
        <div className="content-wrapper">
          <span className="status-dot pending"></span>
          <span className='content-head'>Pending :</span>
          <span className='content-data'>{item?.pending_count} students</span>
        </div>
      </div>
    </div>
  </div>
);
    }
  }}
  grid={false}
  height={150}
  borderRadius={5}
  width={chartWidth} 
  margin={{
    left: 0,
    right: 35,
    top: 10,
    bottom: 25
  }}
/>
              <div className="bottom-icons" style={{ width: `${chartWidth - 35}px` }}>
                {completionStatus?.scoreRatioRes?.map((item, i,arr) => (
                  <Fragment key={i}>
                    <TestSvgIcon 
                      libType={item.libtype}
                      component="DashBoard"
                      style={{ width: '12px', height: '12px',stroke: '#98A2B3' }}
                    />
                    {i !== arr.length -1 &&(
                    // <div className='svg-line'>
                    <svg width="1" height="9" viewBox="0 0 1 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M0.56842 0.242126V9.00002" stroke="#AFAFAF" strokeWidth="0.547368"/>
                    </svg>
                    // </div>
                    )}
                  </Fragment>
                ))}
              </div>

            </div>
          </div>

          <div className="items-label">Items</div>
        </div>
      </div>
      </>
    )}
    </div>
  );
}